import React from "react";
import Dropzone from "react-dropzone";
import { Icon } from "@iconify/react";

const UploadFile = ({ onUpload }) => {
  return (
    <Dropzone accept={"*"} onDrop={(acceptedFiles) => onUpload(acceptedFiles)}>
      {({ getRootProps, getInputProps }) => (
        <section>
          <div {...getRootProps()}>
            <input className="uploadFile" {...getInputProps()} />

            <label htmlFor="file">
              {" "}
              <i>
                <Icon icon="akar-icons:image" />
              </i>{" "}
              Tap or click here to start uplaoding images
            </label>
          </div>
        </section>
      )}
    </Dropzone>
  );
};
export default UploadFile;
